import { useState, useEffect, useRef } from 'react';
import {
  IXONECertificationWrapper,
  TYPE_VIEW,
} from 'common/components/product-add/IXONECertificationWrapper';

import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { useLocation } from 'react-router-dom';

import { useIsMutating } from '@tanstack/react-query';

import * as selectorsGlobal from '@redux/global/selectors';

import { Menu, Dropdown, Modal, notification, Tooltip, Typography } from 'antd';

import {
  SubnodeOutlined,
  DownloadOutlined,
  UploadOutlined,
  MenuUnfoldOutlined,
  FileAddOutlined,
  DeleteOutlined,
  CopyOutlined,
  BlockOutlined,
  RightOutlined,
} from '@ant-design/icons';

import {
  ButtonSmallIcon,
  RibbonButton,
  UploadFile,
  dialogFunction,
  DownloadFormItem,
  MinimumRequirementsValidate,
  ReassignProductToMemberModal,
  CustomNotification,
  WithLoading,
} from 'common/components';

import ProductSubscriptionModal from 'common/components/product-subscription/ProductSubscriptionModal';
import CreateProductViaFormModal from 'common/components/product-add/CreateProductViaFormModal';
import GDSNPublication from 'common/components/product-publication-setup/GDSNPublication';
import MoveProductsToMember from '../../controls/product/MoveProductsToMember';
// import AssignProductToSupplier from '../../controls/product/AssignProductToSupplier';
import WithdrawPublicationButton from '../../controls/product/WithdrawPublicationButton';
import BulkEditProduct from '../../controls/product/BulkEditProduct';
import DownloadNifFormSection from './DownloadNifFormSection';
import HistoryEntity from 'pages/home/ribbon/form-manange/components/form-history-grid/HistoryEntity';
import CopyProductPropertiesModal from 'pages/home/ribbon/components/modal/bulk-edit-product/CopyProductPropertiesModal';
import { OverlayActionMenuList } from 'pages/home/ribbon/components/sections/product/components/overlay-action-dropdown';
import { CanShow } from 'common/components/wrapper/show-condition';
import AssignCategoryToProduct from './AssignCategoryToProduct';
import AssignCategoryToProductModal from '../../controls/product/AssignCategoryToProductModal';
import ExportProductPropertiesModal from '../../modal/bulk-edit-product/ExportProductPropertiesModal';
import ImportProductBulkEditModal from '../../modal/bulk-edit-product/ImportProductBulkEditModal';
import BulkProductOverlay from './components/bulk-product-overlay-dropdown/BulkProductOverlay';
import MakeProductActive from './MakeProductActive';

import { toggleReloadGridProduct } from 'pages/branded-products/controllers/actions';
import gridSelector from 'common/components/grid-view/controllers/selectors';
import ErrorModal from 'common/components/product-publication-setup/ErrorModal.js';
import { useCheckPermissions } from 'hooks/useCheckPermissions';
import useCheckFavoriteRoute from 'hooks/useCheckFavoriteRoute';

import * as actionsGridView from 'common/components/grid-view/controllers/actions';

import { Can } from 'context/Can';

import {
  useCheckAllowDeleteProducts,
  usePermissionEditSharedProduct,
  useCheckIsSuperAdmin,
  useCheckAllowEditProducts,
  useGlobalModal,
  useDispatchReloadPage,
  useQueryBrandingNavigation,
} from 'hooks';
import { useCheckPermissionOR } from 'hooks/useCheckPermissions';
import {
  EXPORT_PRODUCT_OVERLAY_PROPERTIES,
  useExportProductOverlayProperty,
  useExportProductProperty,
  useExportSearchProductProperty,
} from '../../modal/bulk-edit-product/hook';
import { useCheckDisabledBulkProductOverlay } from './components/bulk-product-overlay-dropdown/useCheckDisabledBulkProductOverlay';

import { SECURE_CONFIG } from 'utils/SecureRoute';
import { saveFile } from 'utils/saveFile';

import ProfessionallyCaptureProductButton from './components/professionally-capture-product/ProfessionallyCaptureProductButton';
import AddProductWarningModal from './components/professionally-capture-product/AddProductWarningModal';
import { useAddProductWarningGate } from './components/professionally-capture-product/useAddProductWarningGate';
import useCheckIXOneCapturePermission from './components/product-upload-wizard/hooks/useCheckIXOneCapturePermission';

import * as memberServices from 'services/members';
import messagesProduct from 'i18n/messages/product';
import messages from 'i18n/messages/home';

import {
  getProductViaSpreadSheet,
  getTdcProductViaSpreadSheet,
  deleteProductItems,
} from 'services/product';
import {
  IMPORT_PRODUCT_FOR_BULK_EDITING,
  IMPORT_PRODUCT_VIA_SPREADSHEET,
  IMPORT_TDC_PRODUCT_VIA_SPREADSHEET,
} from 'services/product/endpoints';

import {
  ABILITY_ACTION,
  ABILITY_SUBJECT,
  PERMISSION_CREATE_PRODUCTS,
  PERMISSION_EDIT_PRODUCTS,
  PERMISSION_VIEW_NEW_ITEM_FORMS,
} from 'static/Permission';

import { UPLOAD_OVERLAYS_BULK_TEMPLATE } from 'services/overlay/endpoints';
import { UPLOAD_MAX_SIZE, ROUTE } from 'static/Constants';

import { useCheckDisableWithdrawPublicationModal } from 'hooks';

import PublicationProduct from 'pages/branded-products/components/publication-product/PublicationProduct';
import PostToRibbonSection from 'pages/branded-products/components/post-to-walmart-krogger/PostToRibbonSection';

import PostToModal from 'pages/branded-products/components/post-to-walmart-krogger/PostToModal';
import ValidateResultModal from './components/upload-template/ValidateResultModal';
import { useMutationImportProduct } from './components/upload-template/queries';

import { OVERLAY } from '../../modal/bulk-edit-product/constants';

import './ProductGridAction.less';

import { useUserInfo } from 'hooks/auth/useUserInfo';

const { SubMenu } = Menu;
const { Text } = Typography;

const defaultSearchParams = {
  searchText: '',
};

const MISSING_IXONE_CAPTURE_PERMISSION_MESSAGE =
  "You haven't been assigned the Product IX-ONE Capture permission. Please contact your company admin to have it added, then try again.";

const ProductGridAction = (props) => {
  const { viewType, memberId, isSelectAllSearchResult, onRequestCapture } =
    props;

  const intl = useIntl();
  const location = useLocation();
  const dispatch = useDispatch();

  const refSearchGridItemModal = useRef();

  const exportProductPropertyMutation = useExportProductProperty();
  const exportSearchProductProperty = useExportSearchProductProperty();

  const exportProductOverlayPropertyMutation =
    useExportProductOverlayProperty();

  //* mock - 11/24/2021
  // const [enabledSubscribe, setEnabledSubscribe] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleSubscriptionModal, setVisibleSubscriptionModal] =
    useState(false);
  const [isPostToModalOpen, setIsPostToModalOpen] = useState(false);

  const {
    isModalVisible: isAddProductWarningVisible,
    guardAddProductClick,
    handleAcknowledge: handleAcknowledgeAddProductWarning,
    dismiss: dismissAddProductWarning,
  } = useAddProductWarningGate();

  const { hasPermissionIXOneCapture } = useCheckIXOneCapturePermission();

  const handleCaptureFromAddProductWarning = () => {
    dismissAddProductWarning();

    if (!hasPermissionIXOneCapture) {
      CustomNotification.warning(MISSING_IXONE_CAPTURE_PERMISSION_MESSAGE, 6);
      return;
    }

    onRequestCapture?.();
  };

  const [updateType, setUploadType] = useState('pim');

  const { checkModalVisible, MODAL_NAMES, openModal, closeModal } =
    useGlobalModal();

  let detailItems = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );
  const paramsAddSearchProductToFolder = useSelector(
    selectorsGlobal.selectParamsAddSearchProductToFolder()
  );

  const { checkAllowEditProductFull, checkAllowBulkEditProducts } =
    useCheckAllowEditProducts();

  const { invalidateBrandingNavigation } = useQueryBrandingNavigation();

  const isFavoriteRoute = useCheckFavoriteRoute();

  const useVisibleModal = [
    visibleSubscriptionModal,
    setVisibleSubscriptionModal,
  ];

  const isAllowBulkEditProduct = checkAllowBulkEditProducts({
    isSelectAllSearchResult,
  });

  const checkPermissionOr = useCheckPermissionOR();

  const { userInfo } = useUserInfo();

  const hasPermissionEditProducts = useCheckPermissions(
    PERMISSION_EDIT_PRODUCTS
  );

  const hasPermissionCreateProducts = useCheckPermissions(
    PERMISSION_CREATE_PRODUCTS
  );

  const hasPermissionEditMember = useCheckPermissions([
    {
      action: ABILITY_ACTION.EDIT,
      subject: ABILITY_SUBJECT.MEMBER,
    },
  ]);

  const hasPermissionEditSharedProduct = usePermissionEditSharedProduct();
  const isSuperAdmin = useCheckIsSuperAdmin();
  const { checkAllowDeleteProductGrid } = useCheckAllowDeleteProducts();

  const selectedItemDetailList = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );

  const isDisabledBulkProductOverlay = useCheckDisabledBulkProductOverlay();

  const reloadGridProducts = useDispatchReloadPage();

  const isAllowActionsPim =
    isSuperAdmin || hasPermissionEditProducts || hasPermissionEditSharedProduct;

  const isAssignCategoryModalOpen = checkModalVisible(
    MODAL_NAMES.ASSIGN_CATEGORY_TO_PRODUCT
  );
  const isAddEditProductModalOpen = checkModalVisible(
    MODAL_NAMES.ADD_EDIT_PRODUCT_MODAL
  );

  const isCopyProductModalOpen = checkModalVisible(
    MODAL_NAMES.COPY_PRODUCT_MODAL
  );

  const isExportModalOpen = checkModalVisible(
    MODAL_NAMES.EXPORT_PROPERTY_MODAL
  );
  const isExportProductOverlayModalOpen = checkModalVisible(
    MODAL_NAMES.EXPORT_BULK_PRODUCT_OVERLAY
  );

  const isImportBulkProductOverlayModalOpen = checkModalVisible(
    MODAL_NAMES.IMPORT_BULK_PRODUCT_OVERLAY
  );

  const isImportProductPropertyModalOpen = checkModalVisible(
    MODAL_NAMES.IMPORT_PROPERTY_MODAL
  );

  const isAllowEditFullFirstProduct = checkAllowEditProductFull(
    detailItems?.[0]
  );
  const viewNewItemForm = useCheckPermissions(PERMISSION_VIEW_NEW_ITEM_FORMS);

  const isExportProductOverlayPropertyLoading = useIsMutating({
    mutationKey: EXPORT_PRODUCT_OVERLAY_PROPERTIES,
  });

  const togglePostToModal = () => {
    setIsPostToModalOpen((prev) => !prev);
  };

  const isOneProductSelected = detailItems?.length === 1;
  const notSelectedItem = detailItems.length === 0;

  const someIsProductOverlay =
    detailItems?.length > 0 &&
    detailItems.some((productItem) => productItem.isOverlayProduct === true);

  const isAllowToDownloadNifForm =
    detailItems.length !== 0 && viewNewItemForm && !someIsProductOverlay;

  const isAllowEditMinimumRequirement =
    isAllowEditFullFirstProduct &&
    isOneProductSelected &&
    !someIsProductOverlay;

  const isDisableCloneProduct =
    !isAllowEditFullFirstProduct ||
    !isOneProductSelected ||
    detailItems[0]?.isOverlayProduct;

  const detailItemIds = detailItems.map((detailItem) => {
    return detailItem.id;
  });

  const isAllowDeleteProducts = checkAllowDeleteProductGrid();

  const isDisableOverlayActions = !checkPermissionOr(SECURE_CONFIG.OVERLAY.OR);

  const isFavorited = location.pathname === '/favorite/favorite-products';

  const checkNotMyOwner = (item) => {
    return !item.isOwner;
  };

  const enabledSubscribe =
    isOneProductSelected &&
    checkNotMyOwner(detailItems[0]) &&
    !someIsProductOverlay;

  const hasCreateMemberProduct =
    viewType === ROUTE.MEMBER_PRODUCTS &&
    memberId !== userInfo?.member?.id &&
    !hasPermissionEditMember;

  const disabledAddProduct = isFavorited || hasCreateMemberProduct;

  const isDisableWithdrawPublicationModal =
    useCheckDisableWithdrawPublicationModal(detailItems?.[0]) ||
    detailItems?.length > 1;

  const handleDownloadTemplateProduct = (type) => async () => {
    try {
      const response =
        type === 'tdc'
          ? await getTdcProductViaSpreadSheet()
          : await getProductViaSpreadSheet();

      const urlPath = type === 'tdc' ? 'fileUrl' : 'url';

      if (response.isSuccess) {
        saveFile(response.data[urlPath]);
      } else {
        notification.error({
          message: response.data.message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onClickUploadTemplate = (type) => () => {
    setVisibleModal(true);
    setUploadType(type);
  };

  const confirmDeleteProducts = () => {
    dialogFunction({
      type: 'warn',
      width: 460,
      content: (
        <Typography style={{ textAlign: 'left' }}>
          <Typography.Paragraph>
            Upon selecting the <Text strong>&quot;Delete&quot;</Text> option
            below, this product&apos;s content will be permanently removed from
            the Product module of the platform.
          </Typography.Paragraph>
          <Typography.Paragraph>
            If you no longer want this product to be visible on the platform,
            please click <Text strong>&quot;Delete&quot;</Text> below.
          </Typography.Paragraph>
        </Typography>
      ),
      okText: 'Delete',
      okButtonProps: {
        type: 'danger',
      },
      onOk: handleDeleteProducts,
    });
  };

  const handleDeleteProducts = async () => {
    try {
      const productIds = detailItems.map((product) => product.id);
      const response = await deleteProductItems({
        ids: productIds,
      });
      const { isSuccess, message, data } = response;
      if (isSuccess) {
        const products = data?.products ?? [];
        const failedProducts = products.filter(
          (product) => product.isDeletedSuccess === false
        );
        const hasSucceeded =
          products.length === 0 ||
          products.some((product) => product.isDeletedSuccess === true);

        if (hasSucceeded) {
          CustomNotification.success('Delete product(s) successfully!');
          dispatch(actionsGridView.updateDetailCurrentItemsSelection([]));
          reloadGridProducts();

          if (isFavoriteRoute) {
            invalidateBrandingNavigation();
          }
        }

        if (failedProducts.length > 0) {
          dialogFunction({
            type: 'warn',
            title: (
              <Typography.Title level={5} style={{ fontSize: 16 }}>
                Cannot delete or archive the selected item(s) because
                professional capture is currently in progress.
              </Typography.Title>
            ),
            content: (
              <div
                style={{
                  textAlign: 'left',
                  maxHeight: '360px',
                  paddingRight: '4px',
                  marginTop: '8px',
                }}
                className='scroller'
              >
                {failedProducts.map((product) => (
                  <div
                    key={product.id}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px',
                      padding: '10px 14px',
                      marginBottom: '8px',
                      backgroundColor: '#fffbe6',
                      border: '1px solid #ffe58f',
                      borderRadius: '4px',
                    }}
                  >
                    <Tooltip
                      title={`${product.productName || product.id}${product.rivirId ? ` - ${product.rivirId}` : ''}`}
                      placement='topLeft'
                    >
                      <Text
                        strong
                        style={{
                          color: '#faad14',
                          fontSize: '14px',
                          display: 'block',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {product.productName || product.id}
                        {product.rivirId && ` - ${product.rivirId}`}
                      </Text>
                    </Tooltip>
                    <Text style={{ fontSize: 13 }}>{product.message}</Text>
                  </div>
                ))}
              </div>
            ),
            okText: 'OK',
            cancelButtonProps: { style: { display: 'none' } },
            width: 460,
          });
        }
      } else {
        CustomNotification.error(message || 'Cannot delete product(s)!');
      }
    } catch (error) {
      CustomNotification.error('Cannot delete product(s)!');
    }
  };

  const onExportProductProperty = (
    exportProperties,
    allPopulated,
    paramsSelectAll = {},
    isSelectAllSearchResult
  ) => {
    if (isSelectAllSearchResult) {
      const newParams = {
        ...paramsSelectAll,
        filters: [
          ...paramsSelectAll.filters,
          ...(paramsSelectAll.filterFromAgGrid || []),
        ],
      };
      exportSearchProductProperty.mutate(
        {
          // productIds: detailItemIds,
          selectedColumns: exportProperties,
          allPopulated,
          ...newParams,
        },
        {
          onSuccess: () => {
            closeModal(MODAL_NAMES.EXPORT_PROPERTY_MODAL);
          },
        }
      );
    } else {
      exportProductPropertyMutation.mutate({
        productIds: detailItemIds,
        selectedColumns: exportProperties,
        allPopulated,
        // ...paramsSelectAll,
      });
    }
  };

  const onExportProductOverlayProperty = (exportProperties) => {
    exportProductOverlayPropertyMutation.mutate({
      productIds: detailItemIds,
      selectedColumns: exportProperties,
      allPopulated: false,
    });
  };

  const renderAddProductMenu = (
    <>
      <Menu.Item
        key='pim-add-product'
        style={{
          backgroundColor: 'inherit',
        }}
      >
        <Can I={ABILITY_ACTION.CREATE} a={ABILITY_SUBJECT.PRODUCT} passThrough>
          {(allowed) => (
            <ButtonSmallIcon
              className='button-item-dropdown'
              icon={<FileAddOutlined />}
              label={messages.createProduct}
              onClick={guardAddProductClick(() =>
                openModal(MODAL_NAMES.ADD_EDIT_PRODUCT_MODAL)
              )}
              disabled={!allowed}
            />
          )}
        </Can>
      </Menu.Item>
      <Menu.Item
        key='pim-download-template'
        style={{
          backgroundColor: 'inherit',
        }}
      >
        <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.PRODUCT} passThrough>
          {(allowed) => (
            <ButtonSmallIcon
              className='button-item-dropdown'
              icon={<DownloadOutlined />}
              label={messages.downloadTemplate}
              onClick={guardAddProductClick(
                handleDownloadTemplateProduct('pim')
              )}
              disabled={!allowed}
            />
          )}
        </Can>
      </Menu.Item>
      <Menu.Item
        key='pim-upload-template'
        style={{
          backgroundColor: 'inherit',
        }}
      >
        <ButtonSmallIcon
          className='button-item-dropdown'
          icon={<UploadOutlined />}
          label={messages.uploadTemplate}
          onClick={guardAddProductClick(onClickUploadTemplate('pim'))}
          disabled={!isAllowActionsPim}
        />
      </Menu.Item>
      <Menu.Item
        key='download-tdc-template'
        style={{
          backgroundColor: 'inherit',
        }}
      >
        <Can I={ABILITY_ACTION.MANAGE} a={ABILITY_SUBJECT.ALL} passThrough>
          {(allowed) => (
            <ButtonSmallIcon
              className='button-item-dropdown'
              icon={<DownloadOutlined />}
              label={messages.downloadTdcTemplate}
              onClick={handleDownloadTemplateProduct('tdc')}
              disabled={!allowed || viewType === ROUTE.MEMBER_PRODUCTS}
            />
          )}
        </Can>
      </Menu.Item>
      <Menu.Item
        key='upload-tdc-template'
        style={{
          backgroundColor: 'inherit',
        }}
        passThrough
      >
        <Can I={ABILITY_ACTION.MANAGE} a={ABILITY_SUBJECT.ALL} passThrough>
          {(allowed) => (
            <ButtonSmallIcon
              className='button-item-dropdown'
              icon={<UploadOutlined />}
              label={messages.uploadTdcTemplate}
              onClick={onClickUploadTemplate('tdc')}
              disabled={!allowed || viewType === ROUTE.MEMBER_PRODUCTS}
            />
          )}
        </Can>
      </Menu.Item>
    </>
  );

  const renderSubMenuAddProduct = (
    <Menu style={{ width: 230 }}>
      <ProfessionallyCaptureProductButton />
      <SubMenu
        key='self-load'
        style={{ backgroundColor: 'inherit' }}
        title={
          <ButtonSmallIcon
            className='button-item-dropdown'
            icon={<DownloadOutlined />}
            label='Self Load'
          />
        }
      >
        {renderAddProductMenu}
      </SubMenu>
    </Menu>
  );

  const menuOptions = (
    <Menu>
      {!someIsProductOverlay ? (
        <Menu.Item
          key='make-active-product'
          style={{
            backgroundColor: 'inherit',
          }}
        >
          <MakeProductActive />
        </Menu.Item>
      ) : null}

      {hasPermissionCreateProducts && (
        <CanShow.SharedOnlyMember>
          <Menu.Item
            key='add-product'
            style={{ padding: 0, margin: 0, backgroundColor: 'inherit' }}
            className='custom-menu-item-dropdown'
          >
            <Dropdown
              overlay={renderSubMenuAddProduct}
              placement='rightTop'
              trigger={['hover']}
              arrow
            >
              <div
                className='dropdown-item-content'
                style={{
                  padding: '4px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '100%',
                  cursor: 'pointer',
                }}
              >
                <ButtonSmallIcon
                  className='button-item-dropdown'
                  icon={<FileAddOutlined />}
                  label={messages.addProduct}
                  disabled={disabledAddProduct}
                />
                <RightOutlined
                  style={{ fontSize: '10px', color: 'rgba(0, 0, 0, 0.45)' }}
                />
              </div>
            </Dropdown>
          </Menu.Item>
        </CanShow.SharedOnlyMember>
      )}

      <Can I={ABILITY_ACTION.CREATE} a={ABILITY_SUBJECT.PRODUCT}>
        <Menu.Item
          key='pim-clone-product'
          style={{
            backgroundColor: 'inherit',
          }}
        >
          <ButtonSmallIcon
            className='button-item-dropdown'
            icon={<CopyOutlined />}
            label={messages.productClone}
            onClick={() => openModal(MODAL_NAMES.COPY_PRODUCT_MODAL)}
            disabled={isDisableCloneProduct}
          />
        </Menu.Item>
      </Can>

      <Menu.Item
        key='overlay-action-item'
        style={{ padding: 0, margin: 0 }}
        className='custom-menu-item-dropdown'
      >
        <Dropdown
          overlay={
            <Menu style={{ width: '200px' }}>
              <OverlayActionMenuList.ProductGrid
                productId={detailItems?.[0]?.id}
              />
            </Menu>
          }
          placement='rightTop'
          trigger={['hover']}
          arrow
        >
          <div
            className='dropdown-item-content'
            style={{
              padding: '4px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              cursor: 'pointer',
            }}
          >
            <ButtonSmallIcon
              className='button-item-dropdown'
              icon={<BlockOutlined />}
              label={'Product Overlay Actions'}
              disabled={isDisableOverlayActions}
            />
            <RightOutlined
              style={{ fontSize: '10px', color: 'rgba(0, 0, 0, 0.45)' }}
            />
          </div>
        </Dropdown>
      </Menu.Item>

      <Menu.Item
        key='bulk-overlay-item'
        style={{ padding: 0, margin: 0 }}
        className='custom-menu-item-dropdown'
      >
        <Dropdown
          overlay={
            <Menu style={{ width: '240px' }}>
              <BulkProductOverlay disabledExport={detailItems?.length === 0} />
            </Menu>
          }
          placement='rightTop'
          trigger={['hover']}
          arrow
        >
          <div
            className='dropdown-item-content'
            style={{
              padding: '4px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              cursor: 'pointer',
            }}
          >
            <RibbonButton
              className='button-item-dropdown'
              icon={<DownloadOutlined />}
              label={'Bulk Product Overlay'}
              size={'small'}
              disabled={isDisabledBulkProductOverlay}
            />
            <RightOutlined
              style={{ fontSize: '10px', color: 'rgba(0, 0, 0, 0.45)' }}
            />
          </div>
        </Dropdown>
      </Menu.Item>

      {isAllowDeleteProducts && (
        <Menu.Item
          key='pim-delete-product'
          style={{ backgroundColor: 'inherit' }}
        >
          <ButtonSmallIcon
            className='button-item-dropdown'
            icon={<DeleteOutlined />}
            label={messages.deleteProduct}
            disabled={detailItems?.length < 1 || someIsProductOverlay}
            onClick={confirmDeleteProducts}
          />
        </Menu.Item>
      )}
      <CanShow.SharedOnlyMember>
        <Menu.Item
          key='pim-subscribe-hierarchies'
          style={{ backgroundColor: 'inherit' }}
        >
          <ButtonSmallIcon
            className='button-item-dropdown'
            icon={<MenuUnfoldOutlined />}
            label={messages.pimSubscribe}
            onClick={() => setVisibleSubscriptionModal(true)}
            disabled={!enabledSubscribe}
          />
        </Menu.Item>

        <Can I={ABILITY_ACTION.MAINTAIN} a={ABILITY_SUBJECT.SYNDICATION}>
          <Menu.Item
            key='gdsn-syndication'
            style={{ backgroundColor: 'inherit' }}
          >
            <GDSNPublication products={detailItems} />
          </Menu.Item>
        </Can>
      </CanShow.SharedOnlyMember>

      <PostToRibbonSection togglePostToModal={togglePostToModal} />

      <CanShow.SharedOnlyMember>
        <Menu.Item
          key='pim-delete-product-publication'
          style={{ backgroundColor: 'inherit' }}
        >
          <WithdrawPublicationButton
            products={detailItems}
            isDisabled={isDisableWithdrawPublicationModal}
          />
        </Menu.Item>
        <Menu.Item
          key='pim-download-nif-form'
          style={{
            backgroundColor: 'inherit',
          }}
          disabled={!isAllowToDownloadNifForm}
        >
          <DownloadNifFormSection
            detailItems={detailItems}
            isAllowToDownloadNifForm={isAllowToDownloadNifForm}
          />
        </Menu.Item>
        <Menu.Item
          key='move-product-to-member'
          style={{ backgroundColor: 'inherit' }}
        >
          <MoveProductsToMember
            ref={refSearchGridItemModal}
            disabled={!isAllowActionsPim || someIsProductOverlay}
          />
        </Menu.Item>
      </CanShow.SharedOnlyMember>
      <SubMenu
        key={'bulk-edit-product'}
        style={{ backgroundColor: 'inherit' }}
        disabled={!isAllowActionsPim || someIsProductOverlay}
        title={
          <RibbonButton
            size='small'
            className='button-item-dropdown'
            icon={<DownloadOutlined />}
            disabled={!isAllowActionsPim || someIsProductOverlay}
            label={messagesProduct.bulkEditProduct}
          />
        }
      >
        <BulkEditProduct
          disabled={!isAllowActionsPim || someIsProductOverlay}
          disabledExport={!isAllowBulkEditProduct}
          selectedProducts={detailItemIds}
          isSelectAllSearchResult={isSelectAllSearchResult}
        />
      </SubMenu>
      <CanShow.SharedOnlyMember>
        <Menu.Item
          key='download-splash-form'
          style={{ backgroundColor: 'inherit' }}
          disabled={notSelectedItem || someIsProductOverlay}
        >
          <DownloadFormItem
            selectedEntityIds={detailItemIds}
            disabled={notSelectedItem || someIsProductOverlay}
            entityType='PIM'
          />
        </Menu.Item>

        <Menu.Item key='history-entity' style={{ backgroundColor: 'inherit' }}>
          <HistoryEntity
            size='small'
            entityId={detailItems?.length > 0 && detailItems[0]?.id}
            entityType='PIM'
            disabled={detailItems?.length !== 1 || someIsProductOverlay}
          />
        </Menu.Item>
      </CanShow.SharedOnlyMember>
      <Menu.Item key='validate-product' style={{ backgroundColor: 'inherit' }}>
        <MinimumRequirementsValidate
          entity={
            detailItems.length === 1 && {
              id: detailItems[0].id,
              name: detailItems[0].productName,
              gtin: detailItems[0].gtin,
              type: 'Product',
              data: detailItems[0],
            }
          }
          disable={!isAllowEditMinimumRequirement}
        />
      </Menu.Item>
      <Can I={ABILITY_ACTION.ASSIGN} a={ABILITY_SUBJECT.PRODUCT_CATEGORY}>
        <Menu.Item
          key='assign-category-to-product'
          style={{ backgroundColor: 'inherit' }}
        >
          <AssignCategoryToProduct isProductDetail={false} />
        </Menu.Item>
      </Can>
      {/* <Menu.Item
        key='assign-product-to-supplier'
        style={{ backgroundColor: 'inherit' }}
      >
        <AssignProductToSupplier />
      </Menu.Item> */}
    </Menu>
  );

  return (
    <>
      <Dropdown overlay={menuOptions} placement='bottomLeft' arrow>
        <RibbonButton icon={<SubnodeOutlined />} label={messages.pimActions} />
      </Dropdown>

      <CreateProductViaFormModal
        memberId={memberId}
        isAddEditProductModalOpen={isAddEditProductModalOpen}
      />

      {visibleModal && (
        <ModalUploadTemplateProduct
          visibleModal={visibleModal}
          turnOffModal={() => setVisibleModal(false)}
          type={updateType}
          memberId={memberId}
        />
      )}

      {visibleSubscriptionModal && (
        <ProductSubscriptionModal
          useVisibleModal={useVisibleModal}
          type='Product'
          modalTitle={intl.formatMessage(messages.subscribeProduct)}
          id={detailItems?.length === 1 && detailItems[0]?.id}
        />
      )}

      {isCopyProductModalOpen && (
        <CopyProductPropertiesModal productId={detailItems[0]?.id} />
      )}
      {isAssignCategoryModalOpen && (
        <AssignCategoryToProductModal isProductDetail={false} />
      )}
      {isExportModalOpen && (
        <ExportProductPropertiesModal
          title={intl.formatMessage(messagesProduct.exportProperties)}
          onExport={onExportProductProperty}
          visible={isExportModalOpen}
          loading={
            exportProductPropertyMutation.isLoading ||
            exportSearchProductProperty.isLoading
          }
          closeModal={() => closeModal(MODAL_NAMES.EXPORT_PROPERTY_MODAL)}
          isSelectAllSearchResult={isSelectAllSearchResult}
          paramsSelectAll={paramsAddSearchProductToFolder}
        />
      )}

      {isExportProductOverlayModalOpen && (
        <ExportProductPropertiesModal
          title={intl.formatMessage(
            messagesProduct.exportPropertiesProductOverlay
          )}
          onExport={onExportProductOverlayProperty}
          visible={isExportProductOverlayModalOpen}
          loading={isExportProductOverlayPropertyLoading}
          closeModal={() => closeModal(MODAL_NAMES.EXPORT_BULK_PRODUCT_OVERLAY)}
          type={OVERLAY}
          isHiddenSelectedRadio={true}
        />
      )}

      {isImportProductPropertyModalOpen && (
        <ImportProductBulkEditModal
          title={intl.formatMessage(messagesProduct.importProductBulkEditTitle)}
          apiUrl={IMPORT_PRODUCT_FOR_BULK_EDITING}
          visible={isImportProductPropertyModalOpen}
          closeModal={() => closeModal(MODAL_NAMES.IMPORT_PROPERTY_MODAL)}
          isGridView
        />
      )}
      {isImportBulkProductOverlayModalOpen && (
        <ImportProductBulkEditModal
          title={intl.formatMessage(
            messagesProduct.importProductOverlayBulkEditTitle
          )}
          apiUrl={UPLOAD_OVERLAYS_BULK_TEMPLATE}
          visible={isImportBulkProductOverlayModalOpen}
          closeModal={() => closeModal(MODAL_NAMES.IMPORT_BULK_PRODUCT_OVERLAY)}
          type={OVERLAY}
          isGridView
        />
      )}
      <ReassignProductToMemberModal
        title='Assign Product(s) to Member'
        ref={refSearchGridItemModal}
        isMultiple={false}
        service={memberServices.getAllMemberForReassign}
        dataPath='data.allMembers'
        params={defaultSearchParams}
        mapSearch={(searchText) => ({ searchText })}
        tagRender={{ value: (itemData) => itemData?.companyName }}
        itemIdName='companyId'
        productList={selectedItemDetailList}
        memberId={userInfo?.member?.id}
      />

      <PublicationProduct isFullView={false} />
      <PostToModal
        togglePostToModal={togglePostToModal}
        isPostToModalOpen={isPostToModalOpen}
        selectedProducts={detailItems}
        isFullView={false}
      />

      <AddProductWarningModal
        visible={isAddProductWarningVisible}
        onAcknowledge={handleAcknowledgeAddProductWarning}
        onCapture={handleCaptureFromAddProductWarning}
        onCancel={dismissAddProductWarning}
      />
    </>
  );
};

export const ModalUploadTemplateProduct = (props) => {
  const { visibleModal, turnOffModal, type, memberId, ...otherProps } = props;
  const [errorList, setErrorList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [validateResultModalState, setValidateResultModalState] = useState({
    visible: false,
    data: null,
    sessionId: null,
  });

  const uploadResponseDataRef = useRef(null);

  const { confirmImportProductViaSpreadSheet } = useMutationImportProduct();

  const { invalidateBrandingNavigation } = useQueryBrandingNavigation();

  useEffect(() => {
    if (!visibleModal) setErrorList([]);
  }, [visibleModal]);

  const dispatch = useDispatch();
  const intl = useIntl();

  const successMessageDescriptor =
    type === 'tdc'
      ? messagesProduct.uploadTdcSuccess
      : messagesProduct.createProductSuccess;

  const handleImportSuccess = (message) => {
    notification.success({
      message: message || intl.formatMessage(successMessageDescriptor),
    });

    turnOffModal();

    if (type === 'tdc') return;

    invalidateBrandingNavigation();

    setTimeout(() => {
      dispatch(toggleReloadGridProduct());
    }, 100);
  };

  const callConfirmImport = (sessionId) => {
    confirmImportProductViaSpreadSheet.mutate(
      { sessionId },
      {
        onSuccess: (result) => {
          if (result?.isSuccess) {
            setValidateResultModalState({
              visible: false,
              data: null,
              sessionId: null,
            });
            handleImportSuccess(
              result?.message || 'Create Product Successfully'
            );
          } else {
            CustomNotification.error(result?.message || 'Server Error');
          }
        },
      }
    );
  };

  const processUploadResponseData = (responseData, shouldConfirm = false) => {
    if (responseData?.validationResults?.length > 0) {
      setValidateResultModalState({
        visible: true,
        data: responseData?.validationResults,
        sessionId: responseData?.sessionId,
      });
      return;
    }

    if (responseData?.errors?.length) {
      setErrorList(responseData?.errors);
      return;
    }

    if (shouldConfirm) {
      callConfirmImport(responseData?.sessionId);
      return;
    }

    handleImportSuccess(responseData?.message);
  };

  const handleResponseUpload = (response, handleConfirmIxOne) => {
    const { data } = response || {};

    if (typeof data?.isSuccess !== 'boolean') return;

    if (!data?.isSuccess) {
      if (data?.errors) {
        setErrorList(data?.errors);
      }
      return;
    }

    const responseData = data?.data;
    uploadResponseDataRef.current = responseData;

    if (responseData?.requiresIxOneShieldConfirmation) {
      handleConfirmIxOne({
        otherInformation: { condition: true },
      });
      return;
    }

    processUploadResponseData(responseData);
  };

  const handleAfterIxOneConfirm = () => {
    const responseData = uploadResponseDataRef.current;
    if (!responseData) return;

    processUploadResponseData(responseData, true);
  };

  const onSubmit = () => {
    try {
      callConfirmImport(validateResultModalState?.sessionId);
    } catch (error) {
      CustomNotification.error('Server Error');
    }
  };

  const apiUrl =
    type === 'tdc'
      ? IMPORT_TDC_PRODUCT_VIA_SPREADSHEET
      : IMPORT_PRODUCT_VIA_SPREADSHEET;

  const nameFormData = type === 'tdc' ? 'file' : 'TemplateFile';

  return (
    <IXONECertificationWrapper
      showModal
      type={TYPE_VIEW.IMPORT_PRODUCT_TEMPLATE}
      onConfirm={handleAfterIxOneConfirm}
      onCancel={() => {
        uploadResponseDataRef.current = null;
      }}
    >
      {(handleConfirmIxOne) => (
        <Modal
          width={'50vw'}
          bodyStyle={{ height: '50vh' }}
          title='Upload Template Product'
          visible={visibleModal}
          onCancel={turnOffModal}
          closable={true}
          maskClosable={false}
          footer={null}
          destroyOnClose
          centered
          {...otherProps}
        >
          <div className='action-product__modal'>
            <WithLoading loading={loading} tip='Data is being validated...'>
              <UploadFile
                uploadAPL={true}
                manualUpload={true}
                isBase64={false}
                showMultiple={false}
                showXlsTemplate={false}
                apiUrl={apiUrl}
                nameFormData={nameFormData}
                showUploadSuccessMsg={false}
                showServerMessage={false}
                notShowMessage={true}
                getResponse={(response) =>
                  handleResponseUpload(response, handleConfirmIxOne)
                }
                maxSize={UPLOAD_MAX_SIZE.GENERAL}
                additionalBodyPayload={memberId && { memberId: memberId }}
                supportTypes={['xlsx', 'xls']}
                getLoading={(loading) => setLoading(loading)}
              />
              <div className='action-product__modal--error-text'>
                {errorList && errorList.length > 0 && (
                  <ErrorModal errorList={errorList} title={'APL Errors'} />
                )}
              </div>
              <div>
                {validateResultModalState?.visible && (
                  <ValidateResultModal
                    loading={confirmImportProductViaSpreadSheet.isLoading}
                    validateResultModalState={validateResultModalState}
                    setValidateResultModalState={setValidateResultModalState}
                    onSubmit={onSubmit}
                  />
                )}
              </div>
            </WithLoading>
          </div>
        </Modal>
      )}
    </IXONECertificationWrapper>
  );
};

export default ProductGridAction;
